module.exports = __webpack_public_path__ + "static/Truck22-0ac9f1c7f505166c21e2d4e4e9623811.png";